import { IPosDataQuery } from 'generated/sanity-graphql';
import { ServiceMode } from 'state/service-mode/types';
import { isDelivery } from 'utils/service-mode';

export default function getRestaurantPosDataPlus(
  posData: IPosDataQuery | undefined,
  serviceMode: ServiceMode | null
) {
  return isDelivery(serviceMode) && posData?.RestaurantPosData?.deliveryPLUs
    ? posData?.RestaurantPosData.deliveryPLUs
    : posData?.RestaurantPosData?.plus;
}
